import {
  firstNonZero,
  fmtForUI,
  parseMaybeNumber,
  range,
  sampleEvery,
} from "../../../../helpers/common";
import { beamMatrixData } from "./aprData";

interface AprInputsType {
  edit1?: string | number;
  edit2?: string | number;
  edit3?: string | number;
  edit6?: string | number;
  edit7?: string | number;
  edit11?: string | number;
  edit12?: string | number;
  edit13?: string | number;
  popupmenu1?: string | number;
  popupmenu2?: string | number;
  popupmenu3?: string | number;
  popupmenu5?: string | number;
  popupmenu6?: string | number;
  popupmenu9?: string | number;
  popupmenu11?: string | number;
  popupmenu16?: string | number;
  reinforChecked?: boolean;
  heavyChecked?: boolean;
  toExcel?: boolean;
}

export interface AprOutputType {
  text2: string;
  text3: string;
  text4: string;
  text5: string;
  text6: string;
  text9: string;
  text10: string;
  text19: string;
  text20: string;
  text21: string;
  text22: string;
  text29: string;
  text30: string;
  xlsx: any | null;
  warnings: string[];
  technical: Record<string, any> | null;
}

export function calculateAll(inputs: AprInputsType) {
  inputs = inputs || {};
  const warnings: string[] = [];

  const {
    edit1,
    edit2,
    edit3,
    edit6,
    edit7,
    edit11,
    edit12,
    edit13,
    popupmenu1,
    popupmenu2,
    popupmenu3,
    popupmenu5,
    popupmenu6,
    popupmenu9,
    popupmenu11,
    popupmenu16,
    reinforChecked,
    heavyChecked,
    toExcel,
  } = inputs;

  const out: AprOutputType = {
    text2: "",
    text3: "",
    text4: "",
    text5: "",
    text6: "",
    text9: "",
    text10: "",
    text19: "",
    text20: "",
    text21: "",
    text22: "",
    text29: "",
    text30: "",
    xlsx: null,
    warnings: [],
    technical: null,
  };

  const edit1Str = typeof edit1 === "string" ? edit1.trim() : edit1;
  const TFFFFFFF =
    String(edit6 || "")
      .trim()
      .toLowerCase() === "nan" ||
    edit6 === undefined ||
    edit6 === null;
  const TFF =
    toExcel === true ||
    (typeof edit1Str === "string" && edit1Str.toLowerCase() === "excel")
      ? 1
      : 0;

  const beamWidthParsed = parseMaybeNumber(edit6);
  let Beam_width: number | number[] = beamWidthParsed.isNaN
    ? NaN
    : beamWidthParsed.val;

  const HSTR_in = parseMaybeNumber(edit1);
  const FOS_in = parseMaybeNumber(edit3);
  const loadOnRacking_in = parseMaybeNumber(edit2);
  const otherBeamH_in = parseMaybeNumber(edit12);
  const loadOnEachL_in = parseMaybeNumber(edit13);
  const defl_in = parseMaybeNumber(edit7);
  const young_in = parseMaybeNumber(edit11);

  const load_on_each_L = loadOnEachL_in.val;
  const Other_Beam_h = otherBeamH_in.val;

  let Sy = 355;

  let a = Number(popupmenu1 || 1);
  let A = 0,
    Agross = 0,
    Ixx = 0,
    Iyy = 0;

  switch (a) {
    case 1:
      Ixx = 0;
      Iyy = 0;
      break;

    case 2:
      A = 257.058;
      Agross = 389.532;
      Ixx = Math.pow(34.246, 2) * A;
      Iyy = Math.pow(17.958, 2) * A;
      break;

    case 3:
      A = 284.048;
      Agross = 431.265;
      Ixx = Math.pow(34.191, 2) * A;
      Iyy = Math.pow(17.93, 2) * A;
      break;

    case 4:
      A = 323.957;
      Agross = 493.297;
      Ixx = Math.pow(34.11, 2) * A;
      Iyy = Math.pow(17.889, 2) * A;
      break;

    case 5:
      A = 217.458;
      Agross = 389.532;
      Ixx = Math.pow(33.133, 2) * A;
      Iyy = Math.pow(19.001, 2) * A;
      break;

    case 6:
      A = 240.048;
      Agross = 431.265;
      Ixx = Math.pow(33.081, 2) * A;
      Iyy = Math.pow(18.968, 2) * A;
      break;

    case 7:
      A = 273.357;
      Agross = 493.297;
      Ixx = Math.pow(33.003, 2) * A;
      Iyy = Math.pow(18.919, 2) * A;
      break;

    case 8:
      A = 276.858;
      Agross = 389.532;
      Ixx = Math.pow(33.009, 2) * A;
      Iyy = Math.pow(17.973, 2) * A;
      break;

    case 9:
      A = 306.048;
      Agross = 431.265;
      Ixx = Math.pow(32.95, 2) * A;
      Iyy = Math.pow(17.944, 2) * A;
      break;

    case 10:
      A = 349.257;
      Agross = 493.297;
      Ixx = Math.pow(32.862, 2) * A;
      Iyy = Math.pow(17.903, 2) * A;
      break;

    case 11:
      A = 418.155;
      Agross = 565.381;
      Ixx = Math.pow(37.426, 2) * A;
      Iyy = Math.pow(24.706, 2) * A;
      break;

    case 12:
      A = 514.95;
      Agross = 699.055;
      Ixx = Math.pow(37.288, 2) * A;
      Iyy = Math.pow(24.456, 2) * A;
      break;

    case 13:
      A = 566.437;
      Agross = 750.732;
      Ixx = Math.pow(44.614, 2) * A;
      Iyy = Math.pow(24.589, 2) * A;
      break;

    case 14:
      A = 374.155;
      Agross = 565.381;
      Ixx = Math.pow(35.819, 2) * A;
      Iyy = Math.pow(25.383, 2) * A;
      break;

    case 15:
      A = 459.95;
      Agross = 699.055;
      Ixx = Math.pow(35.67, 2) * A;
      Iyy = Math.pow(25.129, 2) * A;
      break;

    case 16:
      A = 511.437;
      Agross = 750.732;
      Ixx = Math.pow(42.817, 2) * A;
      Iyy = Math.pow(25.359, 2) * A;
      break;

    case 17:
      A = 440.155;
      Agross = 565.381;
      Ixx = Math.pow(36.486, 2) * A;
      Iyy = Math.pow(24.748, 2) * A;
      break;

    case 18:
      A = 542.45;
      Agross = 699.055;
      Ixx = Math.pow(36.337, 2) * A;
      Iyy = Math.pow(24.495, 2) * A;
      break;

    case 19:
      A = 593.937;
      Agross = 750.732;
      Ixx = Math.pow(43.575, 2) * A;
      Iyy = Math.pow(24.532, 2) * A;
      break;

    case 20:
      A = 366.315;
      Agross = 487.712;
      Ixx = Math.pow(35.762, 2) * A;
      Iyy = Math.pow(19.236, 2) * A;
      Sy = 275;
      break;

    case 21:
      A = 422.1;
      Agross = 0;
      Ixx = Math.pow(37.4, 2) * A;
      Iyy = Math.pow(25.2, 2) * A;
      break;

    case 22:
      A = 525.0;
      Agross = 0;
      Ixx = Math.pow(37.3, 2) * A;
      Iyy = Math.pow(25.4, 2) * A;
      break;

    case 23:
      A = 448.9;
      Agross = 0;
      Ixx = Math.pow(44.7, 2) * A;
      Iyy = Math.pow(24.8, 2) * A;
      break;

    case 24:
      A = 570.6;
      Agross = 0;
      Ixx = Math.pow(44.6, 2) * A;
      Iyy = Math.pow(25.3, 2) * A;
      break;

    default:
      break;
  }

  if (!(Ixx > 0.1 && Iyy > 0.1)) {
    if (TFFFFFFF) {
      out.text4 =
        "Please Select the type uprights required OR Enter Cross-Beam width";
      warnings.push(out.text4);
    } else {
      out.text6 =
        "Please select a valid uprights or ensure uprights produces valid Ixx/Iyy.";
      warnings.push(out.text6);
    }
    out.text3 = "0.00";
    out.text2 = "Frame Load (kg)";
    out.warnings = warnings;
    out.technical = {
      A,
      Ixx,
      Iyy,
    };
    return out;
  }

  let E = 2.05e5;
  let Ixxsema = Ixx;
  if (Ixxsema === 0) Ixxsema = NaN;

  let Heavier_frame_load = NaN;

  let HSTR;
  if (TFF === 1) {
    HSTR = range(600, 3500, 100);
    Beam_width = range(1000, 4000, 50);
  } else {
    if (!HSTR_in.isNaN) HSTR = HSTR_in.val;
    else HSTR = NaN;
  }

  if (TFF < 1 && (Number.isNaN(HSTR) || (HSTR as number) <= 50) && TFFFFFFF) {
    out.text6 = "Please Enter Height of Structure";
    warnings.push(out.text6);
    out.text3 = "0.00";
    out.text2 = "Frame Load (kg)";
    out.warnings = warnings;
    out.technical = { A, Ixx, Iyy };
    return out;
  }

  let kx: number;
  const beam_levels = Number(popupmenu6 || 1);
  if (beam_levels === 2) {
    kx = 2;
  } else {
    const nooryes = Number(popupmenu5 || 1);
    if (nooryes === 1) {
      const soo = Number(popupmenu3 || 1);
      kx = soo === 1 ? 1.5 : 1.25;
    } else {
      kx = 1.75;
    }
  }

  const rx = Math.sqrt(Ixx / A);
  const ry = Math.sqrt(Iyy / A);

  if (!otherBeamH_in.isNaN && Other_Beam_h > 50) {
    if (Array.isArray(HSTR)) HSTR = HSTR.concat(Other_Beam_h);
    else {
      HSTR = isNaN(HSTR) ? [Other_Beam_h] : [HSTR, Other_Beam_h];
    }
  }

  const SRy_scalar =
    Number(popupmenu2) === 1 ? (0.85 * 1200) / ry : (0.7 * 1400) / ry;
  let SRx;
  if (Array.isArray(HSTR)) {
    SRx = HSTR.map((h) => (kx * h) / rx);
    SRx = SRx.map((v) => Math.max(v, SRy_scalar));
  } else {
    SRx = Math.max((kx * HSTR) / rx, SRy_scalar);
  }

  const technical = {
    A,
    Agross,
    Ixx,
    Iyy,
    rx,
    ry,
    SRy_scalar,
    SRx: Array.isArray(SRx) ? SRx.slice() : SRx,
  };

  if (Array.isArray(SRx)) {
    if (Math.max(...SRx) > 200) {
      const msg =
        "THIS SLENDERNESS RATIO EXCEEDS THE MAXIMUM VALUE OF 200 AS ALLOWABLE UNDER SEMA GUIDELINES";
      warnings.push(msg);
      out.text6 = msg;
      out.text3 = "0.00";
      out.text2 = "Frame Load (kg)";
      out.warnings = warnings;
      out.technical = technical;
      return out;
    }
  } else {
    if (SRx > 200) {
      const msg =
        "THIS SLENDERNESS RATIO EXCEEDS THE MAXIMUM VALUE OF 200 AS ALLOWABLE UNDER SEMA GUIDELINES";
      warnings.push(msg);
      out.text6 = msg;
      out.text3 = "0.00";
      out.text2 = "Frame Load (kg)";
      out.warnings = warnings;
      out.technical = technical;
      return out;
    }
  }

  const computePcAndFrameLoad = (sr: number) => {
    const Pcr = (Math.PI ** 2 * E * A) / sr ** 2;
    const Perry = sr <= 20 ? 0.0 : 0.002 * (sr - 20);
    const acoef = A * Sy + (1 + Perry) * Pcr;
    const bcoef = 4 * (A * Sy) * Pcr;
    const disc = Math.max(0, acoef ** 2 - bcoef);
    const Pc5950 = 0.5 * (acoef - Math.sqrt(disc));
    const Pc_final = Math.min(Pcr, Pc5950);
    const pc5950frameloadkg =
      ((Pc_final / 9.81) * 2) / (FOS_in.isNaN ? 1 : FOS_in.val || 1);
    const frameloadkg = pc5950frameloadkg;
    return { Pcr, Perry, Pc_final, pc5950frameloadkg, frameloadkg };
  };

  let Pc_final_arr, pc5950frameloadkg_arr, frameloadkg;
  let Pcr_arr, Perry_arr;

  if (Array.isArray(SRx)) {
    const Pc_final_list = [];
    const pc_list = [];
    const fr_list = [];
    const pcr_list = [];
    const perry_list = [];
    for (let i = 0; i < SRx.length; ++i) {
      const r = computePcAndFrameLoad(SRx[i]);
      pcr_list.push(r.Pcr);
      perry_list.push(r.Perry);
      Pc_final_list.push(r.Pc_final);
      pc_list.push(r.pc5950frameloadkg);
      fr_list.push(r.frameloadkg);
    }
    Pc_final_arr = Pc_final_list;
    pc5950frameloadkg_arr = pc_list;
    frameloadkg = fr_list;
    Pcr_arr = pcr_list;
    Perry_arr = perry_list;
  } else {
    const res = computePcAndFrameLoad(SRx);
    Pc_final_arr = res.Pc_final;
    pc5950frameloadkg_arr = res.pc5950frameloadkg;
    frameloadkg = res.frameloadkg;
    Pcr_arr = res.Pcr;
    Perry_arr = res.Perry;
  }

  const Lighter_frame_load = frameloadkg;

  if (TFF === 1) {
    out.xlsx = {
      HSTR: Array.isArray(HSTR) ? HSTR.slice() : [HSTR],
      frameLoad: Array.isArray(pc5950frameloadkg_arr)
        ? pc5950frameloadkg_arr.slice()
        : [pc5950frameloadkg_arr],
      Beam_width: Array.isArray(Beam_width) ? Beam_width.slice() : [Beam_width],
      technical,
    };
    out.text3 = "";
    out.text2 = "SEE EXCEL SHEET";
    out.text9 = "";
    out.text10 = "";
    out.warnings = warnings;
    out.technical = technical;
    return out;
  }

  let First_beam_level__ = Array.isArray(frameloadkg)
    ? sampleEvery(frameloadkg, 10, 0)
    : [frameloadkg];
  let Second_beam_level__ = Array.isArray(frameloadkg)
    ? sampleEvery(frameloadkg, 10, 1)
    : [];
  if (Second_beam_level__.length === 0) Second_beam_level__ = [0];

  const loadonracking = loadOnRacking_in.isNaN ? NaN : loadOnRacking_in.val;

  if (reinforChecked) {
    if (
      a > 0.5 &&
      firstNonZero(Second_beam_level__) > 1 &&
      Number(loadonracking) > firstNonZero(First_beam_level__)
    ) {
      if (loadOnEachL_in.isNaN) {
        out.text6 = "Please Enter the Load on each Level";
        warnings.push(out.text6);
        out.text3 = "0.00";
        out.text2 = "Frame Load (kg)";
        out.warnings = warnings;
        out.technical = technical;
        return out;
      }

      let level_reinf = 0;
      let load_at_x_level = loadonracking;
      let firstLevel = firstNonZero(First_beam_level__);
      const secondLevel = firstNonZero(Second_beam_level__);
      const loadStep = load_on_each_L;

      while (load_at_x_level > firstLevel && loadStep > 0) {
        level_reinf++;
        load_at_x_level -= loadStep;

        if (firstLevel !== secondLevel) {
          firstLevel = secondLevel;
        }
      }

      if (loadonracking > firstNonZero(First_beam_level__) * 2) {
        const msg =
          "WARNING: REINFORCEMENT CANNOT BE USED IN THIS CASE; THE REINFORCED LEVEL WILL FAIL";
        out.text4 = msg;
        warnings.push(msg);
        frameloadkg = 0;
      } else {
        frameloadkg = load_at_x_level + load_on_each_L * level_reinf;
        out.text29 = String(level_reinf);
        out.text30 = "Reinforcement Level";
      }
    }
    if (
      !Number.isNaN(loadonracking) &&
      loadonracking < firstNonZero(Lighter_frame_load)
    ) {
      const msg = "Reinforcement is NOT Required";
      out.text6 = msg;
      warnings.push(msg);
    }
  }

  if (heavyChecked) {
    let hhhhhy = Number(popupmenu16 || 1);
    switch (hhhhhy) {
      case 1:
        out.text4 = "Please Select the Heavier type uprights required";
        warnings.push(out.text4);
        Ixx = 0;
        Iyy = 0;
        break;
      case 2:
        A = 257.058;
        Agross = 389.532;
        Ixx = Math.pow(34.246, 2) * A;
        Iyy = Math.pow(17.958, 2) * A;
        break;
      case 3:
        A = 284.048;
        Agross = 431.265;
        Ixx = Math.pow(34.191, 2) * A;
        Iyy = Math.pow(17.93, 2) * A;
        break;
      case 4:
        A = 323.957;
        Agross = 493.297;
        Ixx = Math.pow(34.11, 2) * A;
        Iyy = Math.pow(17.889, 2) * A;
        break;
      case 5:
        A = 217.458;
        Agross = 389.532;
        Ixx = Math.pow(33.133, 2) * A;
        Iyy = Math.pow(19.001, 2) * A;
        break;
      case 6:
        A = 240.048;
        Agross = 431.265;
        Ixx = Math.pow(33.081, 2) * A;
        Iyy = Math.pow(18.968, 2) * A;
        break;
      case 7:
        A = 273.357;
        Agross = 493.297;
        Ixx = Math.pow(33.003, 2) * A;
        Iyy = Math.pow(18.919, 2) * A;
        break;
      case 8:
        A = 276.858;
        Agross = 389.532;
        Ixx = Math.pow(33.009, 2) * A;
        Iyy = Math.pow(17.973, 2) * A;
        break;
      case 9:
        A = 306.048;
        Agross = 431.265;
        Ixx = Math.pow(32.95, 2) * A;
        Iyy = Math.pow(17.944, 2) * A;
        break;
      case 10:
        A = 349.257;
        Agross = 493.297;
        Ixx = Math.pow(32.862, 2) * A;
        Iyy = Math.pow(17.903, 2) * A;
        break;
      case 11:
        A = 418.155;
        Agross = 565.381;
        Ixx = Math.pow(37.426, 2) * A;
        Iyy = Math.pow(24.706, 2) * A;
        break;
      case 12:
        A = 514.95;
        Agross = 699.055;
        Ixx = Math.pow(37.288, 2) * A;
        Iyy = Math.pow(24.456, 2) * A;
        break;
      case 13:
        A = 566.437;
        Agross = 750.732;
        Ixx = Math.pow(44.614, 2) * A;
        Iyy = Math.pow(24.589, 2) * A;
        break;
      case 14:
        A = 374.155;
        Agross = 565.381;
        Ixx = Math.pow(35.819, 2) * A;
        Iyy = Math.pow(25.383, 2) * A;
        break;
      case 15:
        A = 459.95;
        Agross = 699.055;
        Ixx = Math.pow(35.67, 2) * A;
        Iyy = Math.pow(25.129, 2) * A;
        break;
      case 16:
        A = 511.437;
        Agross = 750.732;
        Ixx = Math.pow(42.817, 2) * A;
        Iyy = Math.pow(25.359, 2) * A;
        break;
      case 17:
        A = 440.155;
        Agross = 565.381;
        Ixx = Math.pow(36.486, 2) * A;
        Iyy = Math.pow(24.748, 2) * A;
        break;
      case 18:
        A = 542.45;
        Agross = 699.055;
        Ixx = Math.pow(36.337, 2) * A;
        Iyy = Math.pow(24.495, 2) * A;
        break;
      case 19:
        A = 593.937;
        Agross = 750.732;
        Ixx = Math.pow(43.575, 2) * A;
        Iyy = Math.pow(24.532, 2) * A;
        break;
      case 20:
        A = 366.315;
        Agross = 487.712;
        Ixx = Math.pow(35.762, 2) * A;
        Iyy = Math.pow(19.236, 2) * A;
        Sy = 275;
        break;
      case 21:
        A = 459.8;
        Agross = 0;
        Ixx = Math.pow(44.7, 2) * A;
        Iyy = Math.pow(24.8, 2) * A;
        break;
      default:
        break;
    }

    if (Ixx > 0.1 && Iyy > 0.1) {
      if (otherBeamH_in.isNaN) {
        out.text4 = "Please Enter The Height of the Other Beam Levels";
        warnings.push(out.text4);
        out.text3 = "0.00";
        out.text2 = "Frame Load (kg)";
        out.warnings = warnings;
        out.technical = technical;
        return out;
      }
      if (loadOnEachL_in.isNaN) {
        out.text6 = "Please Enter the Load on each Level";
        warnings.push(out.text6);
        out.text3 = "0.00";
        out.text2 = "Frame Load (kg)";
        out.warnings = warnings;
        out.technical = technical;
        return out;
      }

      const rx2 = Math.sqrt(Ixx / A);
      const ry2 = Math.sqrt(Iyy / A);
      const HSTRval = (Array.isArray(HSTR) ? firstNonZero(HSTR) : HSTR) || 0;
      const SRx2 = Math.max(
        (kx * HSTRval) / rx2,
        Number(popupmenu2) === 1 ? (0.85 * 1200) / ry2 : (0.7 * 1400) / ry2,
      );
      const Pcr2 = (Math.PI ** 2 * E * A) / SRx2 ** 2;
      const Perry2 = SRx2 <= 20 ? 0 : 0.002 * (SRx2 - 20);
      const a2 = A * Sy + (1 + Perry2) * Pcr2;
      const b2 = 4 * (A * Sy) * Pcr2;
      const disc2 = Math.max(0, a2 * a2 - b2);
      const Pc59502 = 0.5 * (a2 - Math.sqrt(disc2));
      const Pc_final2 = Math.min(Pcr2, Pc59502);
      const pc5950frameloadkg2 =
        ((Pc_final2 / 9.81) * 2) / (FOS_in.isNaN ? 1 : FOS_in.val || 1);
      const frameloadkg2 = pc5950frameloadkg2;
      Heavier_frame_load = frameloadkg2;

      let anyeeee = loadonracking;
      let level_heavierpro = 0;
      while (anyeeee > firstNonZero(Lighter_frame_load) && load_on_each_L > 0) {
        level_heavierpro++;
        anyeeee -= load_on_each_L;
      }
      if (loadonracking < firstNonZero(Lighter_frame_load)) {
        const msg = "Reinforcement is NOT Required";
        warnings.push(msg);
        out.text6 = msg;
      }
      if (loadonracking > Heavier_frame_load) {
        const msg =
          "STRUCTURE HAS BEEN OVER LOADED. CONSIDER USING A HEAVIER UPRIGHTS AT THE BASE";
        warnings.push(msg);
        out.text6 = msg;
        frameloadkg = 0;
      } else {
        frameloadkg = anyeeee + load_on_each_L * level_heavierpro;
        out.text29 = String(level_heavierpro);
        out.text30 = "Heavier Uprights Level";
      }
    }
  }

  const reducedData = Array.isArray(frameloadkg)
    ? frameloadkg?.map((n) => n * 0.9)
    : frameloadkg * 0.9;
  out.text3 = fmtForUI(reducedData);
  out.text2 = "Frame Load (kg)";

  const capacityForPercent = Number.isFinite(Heavier_frame_load)
    ? firstNonZero(Heavier_frame_load)
    : firstNonZero(Lighter_frame_load);

  if (!Number.isNaN(loadonracking) && loadonracking > 0.1) {
    const denom =
      Number(capacityForPercent) || Number(firstNonZero(frameloadkg)) || 1;
    const loadused = (loadonracking / denom) * 100;
    if (!Number.isFinite(loadused) || denom === 0) {
      out.text10 = "---";
      out.text9 = "% Load Used";
      const msg =
        "STRUCTURE HAS BEEN OVER LOADED. CONSIDER USING A HEAVIER UPRIGHTS AT THE BASE";
      warnings.push(msg);
      out.text6 = msg;
    } else {
      out.text10 = Number(loadused.toFixed(2)).toString();
      out.text9 = "% Load Used";
    }
  }

  let young = young_in.isNaN ? 205 : young_in.val;
  E = young * 1e3;
  const cross_section = Number(popupmenu9 || 1);
  let I = 0;
  let Beamttt = 0;
  let Kb = 0;
  switch (cross_section) {
    case 1:
      I = 0;
      break;
    case 2:
      I = 146651.653;
      Beamttt = 60;
      Kb = 45000000;
      break;
    case 3:
      I = 371414.065;
      Beamttt = 87;
      Kb = 60000000;
      break;
    case 4:
      I = 543313.452;
      Beamttt = 101;
      Kb = 65000000;
      break;
    case 5:
      I = 700455.178;
      Beamttt = 101;
      Kb = 65000000;
      break;
    case 6:
      I = 694911;
      Beamttt = 86;
      Kb = 29497 * 1000;
      break;
    case 7:
      I = 715751;
      Beamttt = 86;
      Kb = 29497 * 1000;
      break;
    case 8:
      I = 777410.878;
      Beamttt = 86;
      Kb = 29497 * 1000;
      break;
    case 9:
      I = 817806.859;
      Beamttt = 86;
      Kb = 29497 * 1000;
      break;
    case 10:
      I = 874293;
      Beamttt = 95;
      Kb = 34431 * 1000;
      break;
    case 11:
      I = 978693.466;
      Beamttt = 95;
      Kb = 34431 * 1000;
      break;
    case 12:
      I = 1029865.497;
      Beamttt = 95;
      Kb = 34431 * 1000;
      break;
    case 13:
      I = 1054298;
      Beamttt = 103;
      Kb = 39241 * 1000;
      break;
    case 14:
      I = 1149442;
      Beamttt = 103;
      Kb = 39241 * 1000;
      break;
    case 15:
      I = 1180756.483;
      Beamttt = 103;
      Kb = 39241 * 1000;
      break;
    case 16:
      I = 1242789.827;
      Beamttt = 103;
      Kb = 39241 * 1000;
      break;
    case 17:
      I = 1594122;
      Beamttt = 123;
      Kb = 48210 * 1000;
      break;
    case 18:
      I = 1787088.296;
      Beamttt = 123;
      Kb = 48210 * 1000;
      break;
    case 19:
      I = 1881901.56;
      Beamttt = 123;
      Kb = 48210 * 1000;
      break;
    case 20:
      I = 2386145;
      Beamttt = 146;
      Kb = 59834 * 1000;
      break;
    case 21:
      I = 2677341.927;
      Beamttt = 146;
      Kb = 59834 * 1000;
      break;
    case 22:
      I = 2820629.801;
      Beamttt = 146;
      Kb = 59834 * 1000;
      break;
    case 23:
      I = 2891699.393;
      Beamttt = 146;
      Kb = 59834 * 1000;
      break;
    case 24:
      I = 171091.73;
      Beamttt = 54;
      break;
    case 25:
      I = 211812.301;
      Beamttt = 54;
      break;
    case 26:
      I = 325179.248;
      Beamttt = 74;
      break;
    case 27:
      I = 402905.454;
      Beamttt = 74;
      break;
    case 28:
      I = 137911.258;
      Beamttt = 54;
      break;
    case 29:
      I = 419890.478;
      Beamttt = 70;
      break;
    case 30:
      I = 464904.535;
      Beamttt = 70;
      break;
    case 31:
      I = 751988.841;
      Beamttt = 90;
      break;
    case 32:
      I = 835310.625;
      Beamttt = 90;
      break;
    case 33:
      I = 938823.747;
      Beamttt = 99;
      break;
    case 34:
      I = 1043989.109;
      Beamttt = 99;
      break;
    case 35:
      I = 1201800.525;
      Beamttt = 110;
      break;
    case 36:
      I = 1340855.334;
      Beamttt = 110;
      break;
    case 37:
      I = 1473811.945;
      Beamttt = 120;
      break;
    case 38:
      I = 1645805.353;
      Beamttt = 120;
      break;
    case 39:
      I = 2084722.357;
      Beamttt = 139;
      break;
    case 40:
      I = 2331228.245;
      Beamttt = 139;
      break;
    case 41:
      I = 2742869.394;
      Beamttt = 156;
      break;
    case 42:
      I = 3070232.276;
      Beamttt = 156;
      break;
    default:
      I = 0;
      Beamttt = 0;
      Kb = 0;
      break;
  }

  const qwert = TFF ? 200 : Beam_width;
  if ((Array.isArray(qwert) ? firstNonZero(qwert) : qwert) > 100 && I > 1) {
    let Y = defl_in.isNaN ? NaN : defl_in.val;
    if (!Number.isFinite(Y) || Y === 0) {
      const bwVal = Array.isArray(Beam_width)
        ? firstNonZero(Beam_width)
        : Beam_width;
      Y = bwVal / 200;
    }
    if (
      Y >
      (Array.isArray(Beam_width) ? firstNonZero(Beam_width) : Beam_width) / 200
    ) {
      const msg =
        "The Cross-Beam Deflection Exceeds The Allowance Under SEMA Code";
      warnings.push(msg);
      out.text6 = msg;
    }
    const typeofloads = Number(popupmenu11 || 1);
    let Max_loading = 0;
    // if (typeofloads === 1) {
    //   const Max_loading_UDL =
    //     (Y * (0.384 * E * I)) /
    //     (0.005 *
    //       Math.pow(
    //         Array.isArray(Beam_width) ? firstNonZero(Beam_width) : Beam_width,
    //         3,
    //       ));
    //   const Max_loading_kg_UDL = Max_loading_UDL / 9.81;
    //   Max_loading = Max_loading_kg_UDL * 2;
    // } else if (typeofloads === 2) {
    //   const bwVal = Array.isArray(Beam_width)
    //     ? firstNonZero(Beam_width)
    //     : Beam_width;
    //   const a_half = bwVal / 4;
    //   const loaddddd =
    //     (24 * E * I * Y) / (a_half * (3 * bwVal * bwVal - 4 * a_half * a_half));
    //   const Max_loading_kg_point_loads = (loaddddd / 9.81) * 2;
    //   Max_loading = Max_loading_kg_point_loads * 2;
    // } else if (typeofloads === 3) {
    //   let firstblev = HSTR_in.isNaN ? NaN : HSTR_in.val;
    //   if (firstblev === 0) firstblev = NaN;
    //   const Ke = Kb / (1 + (Kb * (firstblev || 0)) / (3 * E * Ixxsema));
    //   const bwVal = Array.isArray(Beam_width)
    //     ? firstNonZero(Beam_width)
    //     : Beam_width;
    //   const load_sema =
    //     (Y * 384 * E * I * (2 + (Ke * bwVal) / (E * I))) /
    //     ((10 + (Ke * bwVal) / (E * I)) * Math.pow(bwVal, 3));
    //   Max_loading = (load_sema / 9.81) * 2;
    // } else if (typeofloads === 4) {
    //   const bwVal = Array.isArray(Beam_width)
    //     ? firstNonZero(Beam_width)
    //     : Beam_width;
    //   const Max_loading_1 =
    //     (Y * 1e-3 * 8 * (E * 1e6) * (I * 1e-12)) / Math.pow(bwVal * 1e-3, 4);
    //   const Max_loading11 = (Max_loading_1 * 2) / 9.81;
    //   const loadrrr =
    //     (2 * (295 * 1e6) * (I * 1e-12)) /
    //     (Math.pow(bwVal * 1e-3, 2) * (Beamttt * 1e-3));
    //   const load_kg1 = (loadrrr * 2) / 9.81;
    //   Max_loading = Math.min(Max_loading11, load_kg1);
    // }

    const bwVal = Array.isArray(Beam_width)
      ? firstNonZero(Beam_width)
      : Beam_width;
    const beamProfileValue = Beamttt;
    const { cprofiles, mprofiles, lengths, matrix } = beamMatrixData;
    const rowIndex = lengths.indexOf(bwVal);
    let colIndex = cprofiles.indexOf(beamProfileValue);

    if (colIndex === -1) {
      colIndex = mprofiles.indexOf(beamProfileValue);
    }

    if (colIndex !== -1 && rowIndex !== -1) {
      const result = matrix[rowIndex][colIndex];
      Max_loading = result !== null ? result : 0;
    } else {
      Max_loading = 0;
    }

    out.text22 =
      Number.isFinite(Max_loading) && Max_loading !== 0
        ? Number(Max_loading.toFixed(2)).toString()
        : "0.00";
    out.text19 = "Max Beam Load (kg)";
    out.text21 = Number.isFinite(Y) ? Number(Y.toFixed(2)).toString() : "0.00";
    out.text20 = "Deflection (mm)";
  } else {
    out.text22 = "0.00";
    out.text19 = "";
    out.text21 = "0.00";
    out.text20 = "";
  }

  out.technical = {
    A,
    Agross,
    Ixx,
    Iyy,
    rx,
    ry,
    SRy_scalar,
    SRx: Array.isArray(SRx) ? SRx.slice() : SRx,
    Pcr: Array.isArray(Pcr_arr) ? Pcr_arr.slice() : Pcr_arr,
    Perry: Array.isArray(Perry_arr) ? Perry_arr.slice() : Perry_arr,
    Pc_final: Array.isArray(Pc_final_arr) ? Pc_final_arr.slice() : Pc_final_arr,
    Lighter_frame_load: Array.isArray(Lighter_frame_load)
      ? Lighter_frame_load.slice()
      : Lighter_frame_load,
    Heavier_frame_load: Heavier_frame_load,
  };

  out.warnings = warnings;

  return out;
}
